import { render, staticRenderFns } from "./import-module-chunk.vue?vue&type=template&id=e8bb57b8&scoped=true&"
import script from "./import-module-chunk.vue?vue&type=script&lang=tsx&"
export * from "./import-module-chunk.vue?vue&type=script&lang=tsx&"
import style0 from "./import-module-chunk.vue?vue&type=style&index=0&id=e8bb57b8&prod&lang=scss&scoped=true&"
import style1 from "./import-module-chunk.vue?vue&type=style&index=1&id=e8bb57b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bb57b8",
  null
  
)

export default component.exports